import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const goToCheckout = () => {
    window.location.href = 'https://www.impulsodigitalstore.com/cart/42985557327949:1';
  };
  return <section className="pt-4 sm:pt-8 pb-14 px-4 overflow-hidden bg-brand-base relative" data-id="element-178">
      <div className="max-w-3xl mx-auto flex flex-col items-center relative z-10" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 sm:px-4 sm:py-2 rounded-full bg-white/[0.04] border border-brand-gold/30 text-brand-gold font-semibold text-xs sm:text-sm mb-3 sm:mb-6 backdrop-blur-sm glow-gold" data-id="element-180">
          <span data-id="element-181">🌾</span> www.impulsodigitalstore.com
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-display tracking-tight mb-2 text-[28px] sm:text-[44px] lg:text-[56px] leading-[1.08]" data-id="element-182">
          <span className="block font-bold text-brand-gold glow-gold text-[24px]" data-id="element-183">
            Volvé a Comer Pan y Postres
          </span>
          <span className="block italic font-semibold text-brand-gold/95 mt-1 glow-gold text-[20px]" data-id="element-184">
            sin picos de glucosa.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-base sm:text-2xl lg:text-3xl font-bold text-brand-cream mb-2 sm:mb-3 leading-tight tracking-wide" data-id="element-185">
          Listo. Desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative w-full max-w-[330px] sm:max-w-lg lg:max-w-xl mb-3 sm:mb-4 mt-2" data-id="element-186">
          <img src="https://cdn.magicpatterns.com/uploads/ufbLZvu6SrHDC8YRVUGsKW/ChatGPT_Image_20_may_2026__12_57_12-removebg-preview.png" alt="Megapack Cocina Sin Gluten y Sin Azúcar" className="relative z-10 w-full h-auto" style={{
          filter: 'drop-shadow(0 14px 24px rgba(0, 0, 0, 0.45))'
        }} data-id="element-187" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="flex flex-col items-center max-w-sm sm:max-w-lg px-4 sm:px-6 mt-1 mb-4 sm:mb-5 gap-2.5 sm:gap-3.5" data-id="element-188">
          <p className="text-[14px] sm:text-lg leading-snug text-center text-brand-cream font-medium" data-id="element-189">
            <span className="text-brand-gold font-bold text-[16px] sm:text-xl" data-id="element-190">
              El sistema N°1
            </span>{' '}
            para comer rico sin gluten, sin azúcar y sin miedo a la glucosa.
          </p>
          <p className="text-[12px] sm:text-[14px] leading-snug text-center text-brand-cream/85 font-normal" data-id="element-191">
            +400 recetas rápidas, económicas y fáciles.
          </p>
        </motion.div>

        <div className="relative inline-block mb-4 sm:mb-5" data-id="element-192">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={goToCheckout} className="bg-brand-gold text-brand-base font-bold text-base sm:text-lg py-3.5 px-8 sm:py-4 sm:px-10 rounded-xl hover:bg-[#C29A35] transition-colors relative z-10 uppercase tracking-wide" data-id="element-193">
            QUIERO MI MEGAPACK AHORA
          </motion.button>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-x-3 sm:gap-x-6 text-[11px] sm:text-sm font-medium text-brand-cream/70 mb-8 whitespace-nowrap" data-id="element-194">
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-195">
            <Shield size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-196" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-197">
            <Lock size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-198" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1 sm:gap-1.5 whitespace-nowrap" data-id="element-199">
            <CreditCard size={14} className="text-brand-gold shrink-0 sm:size-4" data-id="element-200" />{' '}
            Mercado Pago
          </span>
        </div>

        <div className="gold-divider w-full max-w-md mb-6" data-id="element-201"></div>
      </div>
    </section>;
}